var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.471 15.827a5.832 5.832 0 0 1-.003 8.247 5.833 5.833 0 1 1-8.248-8.248 5.832 5.832 0 0 1 8.251.001Z",
    fill: "#62AA51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.376 15.77a4.375 4.375 0 1 0 0 8.75 4.375 4.375 0 0 0 0-8.75Z",
    fill: "#62AA51",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.752 31.64a4.376 4.376 0 1 0 0 8.752 4.376 4.376 0 0 0 0-8.752Z",
    fill: "#62AA51",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.472 48.823a4.376 4.376 0 1 1-6.194 6.184 4.376 4.376 0 0 1 6.194-6.184Zm30.405 1.756a2.92 2.92 0 0 1 0 4.126 2.918 2.918 0 1 1 0-4.126Zm6.432-16.08c.855.854.86 2.238.003 3.095a2.195 2.195 0 0 1-3.096-.003 2.187 2.187 0 0 1 .003-3.09 2.18 2.18 0 0 1 3.09-.003ZM36.275 54.891a3.646 3.646 0 1 0 0 7.292 3.646 3.646 0 0 0 0-7.292Z",
    fill: "#62AA51",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.852 9.915a5.103 5.103 0 1 1-7.219 7.217 5.104 5.104 0 0 1 7.219-7.217Z",
    fill: "#62AA51",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.5fd911e76cc9fffea2cdadbe138da4d1.svg";
export { ForwardRef as ReactComponent };